import styled from 'styled-components';
import { colors, smallShadow, spacing } from 'ui/theme';

import { EventSummaryChart } from './chart';
import { EventFilterBanner } from './filterBanner';
import { EventSummaryTable } from './table';

const Wrapper = styled.div`
  border-radius: ${spacing.half};
  background-color: ${colors.white};
  overflow: hidden;
  ${smallShadow};
`;

export const EventSummaryData = () => (
  <Wrapper>
    <EventFilterBanner />
    <EventSummaryChart />
    <EventSummaryTable />
  </Wrapper>
);
